
import ThemeDropdown from '../forms/multiselect-dropdown';
import { searchEvent, SearchFilterEventEventData, searchFilterEventUpdate, searchFilterResetEvent } from "../search/search-events";

export default class LocationMapFilter extends ThemeDropdown {
    private filterEventName: string;
    constructor(
        dropdownElementID: string,
        filterEventName: string,
        isMultiSelect: boolean,
        allItemsSelected: boolean) {
        super(dropdownElementID, isMultiSelect, allItemsSelected)
        this.filterEventName = filterEventName;
        this.Init();
    }

    // Started when the search filter is initialized
    Init() {
        searchEvent.on(searchFilterResetEvent, () => {
            this.Reset();
        });
    }

    // Override the UpdateSelectedIds method to send an event after updating the filter
    UpdateSelectedIds(dropdownElement: HTMLElement, ignoreEvents: boolean = false): void {
        // If the refresh doesn't need to send an update to the search results, return
        super.UpdateSelectedIds(dropdownElement, ignoreEvents);
        const dropdownBtn = dropdownElement.querySelector('.btn');
        // Send an event to the listing widget
        const filterEventData: SearchFilterEventEventData = {
            searchKey: this.filterEventName,
            searchValue: dropdownBtn.getAttribute("data-selected-ids")
        };

        // Emit the event
        searchEvent.emit(searchFilterEventUpdate, filterEventData);
    }

    AddEventListeners() {
        super.AddEventListeners();
        const clearButtons = document.querySelectorAll<HTMLButtonElement>('.clear-button');

        clearButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const liveRegion = btn.nextElementSibling as HTMLDivElement;
                searchEvent.emit(searchFilterResetEvent);
                btn.setAttribute('aria-pressed', 'true');
                this.UpdateClearButton();
                if (liveRegion) {
                    setTimeout(() => {
                        liveRegion.textContent = 'All filters have been cleared.';
                        setTimeout(() => {
                            liveRegion.textContent = '';
                        }, 3000);

                    }, 200);
                }
            })
        })
    }
}
